/**
 * Códigos de error del dominio. El servidor los emite y el cliente decide cómo
 * presentarlos, sin depender de comparar cadenas de texto traducidas.
 */
export const CODIGOS_ERROR = {
  LIMITE_ASIENTOS_ALCANZADO: 'LIMITE_ASIENTOS_ALCANZADO',
  SUSCRIPCION_INACTIVA: 'SUSCRIPCION_INACTIVA',
  CICLO_JERARQUIA: 'CICLO_JERARQUIA',
  UBICACION_CON_DEPENDENCIAS: 'UBICACION_CON_DEPENDENCIAS',
  ACTIVO_CON_HISTORIAL: 'ACTIVO_CON_HISTORIAL',
  SOLICITUD_YA_RESUELTA: 'SOLICITUD_YA_RESUELTA',
  /** Una OT completada no se edita ni se reprograma: para cambiarla primero hay que reabrirla. */
  OT_COMPLETADA: 'OT_COMPLETADA',
  OT_CON_SUBORDENES_ABIERTAS: 'OT_CON_SUBORDENES_ABIERTAS',
  RANGO_FECHAS_INVALIDO: 'RANGO_FECHAS_INVALIDO',
  CAMPOS_REQUERIDOS_SIN_RESPONDER: 'CAMPOS_REQUERIDOS_SIN_RESPONDER',
  CONDICION_INVALIDA: 'CONDICION_INVALIDA',
  USUARIO_CON_ASIGNACIONES: 'USUARIO_CON_ASIGNACIONES',
  QR_DUPLICADO: 'QR_DUPLICADO',
  /** Un tag RFID ya está vinculado a otro activo del tenant. */
  RFID_DUPLICADO: 'RFID_DUPLICADO',
  TIPO_FALLA_SIMILAR: 'TIPO_FALLA_SIMILAR',
  GRUPO_MIEMBRO_UNICO: 'GRUPO_MIEMBRO_UNICO',
  STOCK_INSUFICIENTE: 'STOCK_INSUFICIENTE',
  PARTE_ELIMINADA: 'PARTE_ELIMINADA',
  REGISTRO_INMUTABLE: 'REGISTRO_INMUTABLE',
  CREDENCIALES_INVALIDAS: 'CREDENCIALES_INVALIDAS',
  CUENTA_BLOQUEADA: 'CUENTA_BLOQUEADA',
  TENANT_NO_RESUELTO: 'TENANT_NO_RESUELTO',
  /**
   * Doble aceptación (continnua_plataforma/docs/FASE-2.md §4): la sesión legada ya no vale
   * porque pasó `LEGACY_TOKENS_ACCEPTED_UNTIL`. El cliente web lo distingue de un 401 corriente
   * para llevar al usuario al acceso por Continnua en vez de mostrar el error.
   */
  SESION_LEGADA_CADUCADA: 'SESION_LEGADA_CADUCADA',
  /**
   * El tenant ya está migrado al núcleo Continnua, así que sus usuarios se dan de alta allí
   * (continnua_plataforma/docs/adr/ADR-007) y llegan aquí por el webhook `membership.changed`.
   * Crear uno local dejaría una credencial que el núcleo no conoce y que el corte de la doble
   * aceptación acabaría echando. `detalles.urlPortal` lleva a dónde hacerlo.
   */
  USUARIOS_GESTIONADOS_EN_NUCLEO: 'USUARIOS_GESTIONADOS_EN_NUCLEO',
  /** §ped: una cuenta compartida (p. ej. la de una sede) debe decir quién hace la solicitud. */
  NOMBRE_PERSONA_REQUERIDO: 'NOMBRE_PERSONA_REQUERIDO',
  /** Un consultante siempre indica la ubicación donde ocurre la falla. */
  UBICACION_REQUERIDA: 'UBICACION_REQUERIDA',

  // Consola de plataforma
  MFA_REQUERIDA: 'MFA_REQUERIDA',
  MFA_INVALIDA: 'MFA_INVALIDA',
  MFA_YA_CONFIRMADA: 'MFA_YA_CONFIRMADA',
  SLUG_EN_USO: 'SLUG_EN_USO',
  PLAN_EN_USO: 'PLAN_EN_USO',
  PLAN_NO_ENCONTRADO: 'PLAN_NO_ENCONTRADO',
  ULTIMO_SUPERADMIN: 'ULTIMO_SUPERADMIN',
  PERIODO_YA_CERRADO: 'PERIODO_YA_CERRADO',
} as const;

export type CodigoError = (typeof CODIGOS_ERROR)[keyof typeof CODIGOS_ERROR];

export interface RespuestaError {
  codigo: CodigoError | 'ERROR_INTERNO' | 'VALIDACION' | 'NO_AUTORIZADO' | 'NO_ENCONTRADO';
  mensaje: string;
  detalles?: unknown;
}
